import { createSlice } from "@reduxjs/toolkit";

const initialFilters = {
  bondNumber: [],
  bondType: [],
  bondSubCategory: [],
  principal: [],
  estate: [],
  lawFirm: [], // will be populated from store.lawfirm.lawfirmId
  attorney: [],
  status: [],
  startDate: null,
  endDate: null,
};

const initialState = {
  page: 0,
  filters: initialFilters,
};

const lawFirmBondsSlice = createSlice({
  name: "lawFirmBonds",
  initialState,
  reducers: {
    setLawFirmBondsPage: (state, action) => {
      state.page = action.payload;
    },
    setLawFirmBondsFilters: (state, action) => {
      const next = action.payload || initialFilters;
      // never clear preselected law firm filter
      if (state.filters?.lawFirm?.length && (!next.lawFirm || next.lawFirm.length === 0)) {
        next.lawFirm = state.filters.lawFirm;
      }
      state.filters = next;
    },
    resetLawFirmBondsState: (state) => {
      const preservedLawFirm = state.filters?.lawFirm || [];
      state.page = 0;
      state.filters = { ...initialFilters, lawFirm: preservedLawFirm };
    },
    setLawFirmPreset: (state, action) => {
      const preset = action.payload || [];
      state.filters.lawFirm = preset;
    }
  },
});

export const { setLawFirmBondsPage, setLawFirmBondsFilters, resetLawFirmBondsState, setLawFirmPreset } = lawFirmBondsSlice.actions;
export default lawFirmBondsSlice.reducer;

